import ITransferRepository from '../domain/ITransferRepository';
import transferRepository from '../infrastructure/repositories/TransferRepository';

class DownloadTransferStockBase64UseCase {
  private readonly _repository: ITransferRepository;

  constructor({ repository }) {
    this._repository = repository;
  }

  execute({ queryParams }: { queryParams: object }) {
    return this._repository.downloadTransferStockBase64({ queryParams });
  }
}

export default new DownloadTransferStockBase64UseCase({
  repository: transferRepository
});

export { DownloadTransferStockBase64UseCase };
